var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bar',{ref:"chart",attrs:{"chart-data":_vm.data,"chart-options":_vm.options,"plugins":_vm.plugins,"width":_vm.width,"height":_vm.height}})}
var staticRenderFns = []

export { render, staticRenderFns }